import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Content, FlexboxGrid } from 'rsuite';
import FlowPageLayout from '../../components/layout/FlowPageLayout';
import PortalHeader from '../../components/layout/PortalHeader';
import { selectCurrentStep, selectFlowSteps, selectCurrentStepKey, selectCurrentFlow } from '../../store/slices/flow/flowSelectors';
import { setCurrentStep, setStepCompletedStatus } from '../../store/slices/flow/flowSlice';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';

const PaymentRedirect = () => {
  const placeNavigate = usePlaceNavigate();
  const dispatch = useDispatch();

  const selectedCurrentStep = useSelector(selectCurrentStep);
  const currentFlow = useSelector(selectCurrentFlow);
  const prevPath = useSelector(selectCurrentStepKey);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={currentFlow} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <FlowPageLayout
            title="Payment"
            hideNextButton
            onBack={() => {
              dispatch(setStepCompletedStatus({ stepNum: selectedCurrentStep, status: false }));
              dispatch(setCurrentStep(selectedCurrentStep - 1));
              placeNavigate(`/${prevPath}`);
            }}
            flowProgressStepsSelector={selectFlowSteps}
            currentStep={selectedCurrentStep}
          >
            <p>A new browser window has been opened which will allow you to complete payment through an external payment provider.</p>
            <p>Please continue with your payment in this new browser window.</p>
          </FlowPageLayout>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default PaymentRedirect;
